
export const SampleYearChoices = [
 2009, 2010, 2011,
 2012, 2013, 2014,
 2015, 2016, 2017,
 2018, 2019, 2020,
 2021, 2022, 2023,
 2024
]

export const VirusFieldChoices = [
  'abpv',
  'amsv1',
  // 'bqcv',
  'cbpv',
  'dwv',
  'iapv',
  'kbv',
  'lsv2',
  // 'sbv',
  'sbpv',
  'vdv',
  'mkv',
  // 'bee_amoeba',
  // 'nosema_apis',
  'nosema_ceranae',
]

export const VirusDisplayAndKey = {
  ABPV: 'abpv',
  "AmSV-1": 'amsv1',
  // BQCV: 'bqcv',
  CBPV: 'cbpv',
  "DWV-A": 'dwv',
  "DWV-B": 'vdv',
  IAPV: 'iapv',
  KBV: 'kbv',
  LSV: 'lsv2',
  // SBV: 'sbv',
  SBPV: 'sbpv',
  MKV: 'mkv',
  // BEE_AMOEBA: 'bee_amoeba'
  // NOSEMA_APIS: 'nosema_apis',
  NOSEMA_CERANAE: 'nosema_ceranae',
}
